<template>
  <v-dialog
    v-model="value" 
    scrollable 
    :max-width="maxWidth"
    :content-class="$vuetify.breakpoint.mdAndDown ? `vitePopup smallScreenPopup ${classes.join(' ')}` : `vitePopup bigScreenPopup ${classes.join(' ')}`"
    no-click-animation
    persistent
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn v-if="showNavigator" small flat @click="getPreviousItem" :disabled="getPreviousItemDisabled"><v-icon large>arrow_left</v-icon>Previous</v-btn>
        <v-toolbar-title class="mx-auto">
          {{title}}
        </v-toolbar-title>
        <v-menu v-if="isShowSettingIcon" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon flat>
              <v-icon>settings</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile>
              <v-list-tile-title>{{ $t('escToClosePopup') }}</v-list-tile-title>
              <v-list-tile-action>
                <v-switch v-model="isEscClose" color="info" class="ml-2"></v-switch>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-if="showNavigator" small flat @click="getNextItem" :disabled="getNextItemDisabled">Next<v-icon large>arrow_right</v-icon></v-btn>
      </v-toolbar>
      <v-card-text ref="simplePopupContainer">
        <div ref="details">
          <v-form ref="form" v-model="isValid" lazy-validation @submit.prevent>
            <v-alert
              v-if="hasAlert"
              v-model="errorAlert"
              dismissible
              type="error">{{$t(errorMessage)}}</v-alert>
            <slot name="input"></slot>
          </v-form>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="!hideFooter">
        <v-layout row justify-space-between>
          <v-flex class="text-xs-left" v-if="!hideLftBtn"><slot name="left_button"><v-btn color="primary" flat @click.stop="firstMethod" :disabled="isLoading || disabledClose">{{leftButtonText}}</v-btn></slot></v-flex>
          <v-flex class="text-xs-right" v-if="!hideRgtBtn">
              <slot name="control1" v-bind="{ loaderButtonError }"></slot>
              <slot name="right_button">    
                <LoaderButton
                  ref="rightButton"
                  :buttonText="rightButtonText"
                  :promiseAwait="onSubmitted"
                  :disabled="!isValid || rightButtonDisabled"
                  :loading="rightButtonLoading"
                  v-model="isLoading"
                  @loaderButtonError="loaderButtonError"
                  class="ml-3"/>
              </slot>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import SimpleTextPopup from './SimpleTextPopup'
import LoaderButton from './LoaderButton'

export default {
  name: 'formSubmitPopup',
  components: {
    LoaderButton
  },
  extends: SimpleTextPopup,
  data () {
    return {
      isLoading: false,
      isValid: true,
      errorAlert: false,
      errorMessage: ''
    }
  },
  methods: {
    clearAlert () {
      this.errorAlert = false
      this.errorMessage = ''
    },
    clearValidation () {
      this.$refs.form.resetValidation()
    },
    validate () {
      return this.$refs.form.validate()
    },
    onSubmitted () {
      this.errorAlert = false
      if (!this.isDisabledValidate && !this.validate()) return Promise.reject(Error(this.$t('dataMissing')))
      return this.secondMethod()
        .catch((error) => {
          this.loaderButtonError(error.message)
          console.error(error)
          throw error
        })
    },
    loaderButtonError (error) {
      if (this.hasAlert) {
        this.errorAlert = true
        this.errorMessage = error
      }
      this.$emit('loaderButtonError', error)
    },
    escClose (e) {
      if (this.value && this.isShowSettingIcon && this.isEscClose && e.keyCode === 27 && this.currentPopup === this.popupId && !this.isLoading && !this.disabledClose) {
        this.hideMethod(0)
      }
    }
  },
  props: {
    isShowSettingIcon: {
      type: Boolean,
      default: true
    },
    hasAlert: {
      type: Boolean,
      default: false
    },
    rightButtonLoading: {
      type: Boolean,
      default: false
    },
    disabledClose: {
      type: Boolean,
      default: false
    },
    isDisabledValidate: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: () => []
    },
    rightButtonDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormSubmitPopup.vue